import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Territories() {
  return (
    <ImageCollectionPage 
      title="Territories" 
      path="/territories" 
      collection="territories" 
    />
  );
}
